/**
 * "nytimes.com/2026/story.html" or "youtube.com/watch?v=dQw4w9WgXcQ": enough to tell one attached
 * link from another when the page has no title. Drops the scheme, `www.` and a trailing slash, but
 * keeps the query string, since some sources (YouTube) identify the post there rather than in the
 * path. `url` is an `AttachedPost`'s, which classification already parsed, so `new URL` can't throw.
 */
export function linkFallbackTitle(url: string): string {
	const { hostname, pathname, search } = new URL(url);
	return `${hostname.replace(/^www\./, '')}${pathname.replace(/\/$/, '')}${search}`;
}
